import { TStoreState } from 'redux/types';
import { createSelector } from '@reduxjs/toolkit';
import {
	TDashboardServicesResponseData,
	TDashboardStore,
	TMonthlySalesInfoResponseData,
	TSalesInfoResponseData,
	TTotalTaxesResponseData,
} from './types';

export const getDashboardState = (state: TStoreState): TDashboardStore => state.dashboard;

export const getDashboard = getDashboardState;

// ==========================================:

export const getTotalTaxes = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): TTotalTaxesResponseData => dashboard.totalTaxes,
);

// ==========================================:

export const getTotalTaxesLoader = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): boolean => dashboard.totalTaxesLoader,
);

// ==========================================:

export const getSalesInfo = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): TSalesInfoResponseData => dashboard.salesInfo,
);

// ==========================================:

export const getSalesInfoLoader = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): boolean => dashboard.salesInfoLoader,
);

// ==========================================:

export const getMonthlySalesInfo = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): TMonthlySalesInfoResponseData => dashboard.monthlySalesInfo,
);

// ==========================================:

export const getMonthlySalesInfoLoader = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): boolean => dashboard.monthlySalesInfoLoader,
);

// ==========================================:

export const getDashboardServices = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): TDashboardServicesResponseData => dashboard.dashboardServices,
);

// ==========================================:

export const getDashboardServicesLoader = createSelector(
	[getDashboard],
	(dashboard: TDashboardStore): boolean => dashboard.dashboardServicesLoader,
);
